import { render, staticRenderFns } from "./EmbeddedCloseButton.vue?vue&type=template&id=19fb67eb&scoped=true&"
import script from "./EmbeddedCloseButton.vue?vue&type=script&lang=js&"
export * from "./EmbeddedCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedCloseButton.vue?vue&type=style&index=0&id=19fb67eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb67eb",
  null
  
)

export default component.exports